import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import App from './App.jsx'
import './index.css'

// Get Clerk publishable key from environment variables
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// Show helpful error if Clerk is not configured
if (!PUBLISHABLE_KEY) {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px',
      backgroundColor: '#f3f4f6',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{ 
        maxWidth: '600px', 
        backgroundColor: 'white', 
        padding: '40px', 
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px', color: '#dc2626' }}>
          ⚠️ Configuration Required
        </h1>
        <p style={{ marginBottom: '16px', color: '#374151' }}>
          <strong>Missing Clerk Publishable Key</strong>
        </p>
        <p style={{ marginBottom: '16px', color: '#6b7280' }}>
          To enable authentication, you need to:
        </p>
        <ol style={{ marginBottom: '16px', marginLeft: '20px', color: '#6b7280' }}>
          <li style={{ marginBottom: '8px' }}>Create a free Clerk account at <a href="https://clerk.com" target="_blank" style={{ color: '#2563eb' }}>clerk.com</a></li>
          <li style={{ marginBottom: '8px' }}>Create a new application</li>
          <li style={{ marginBottom: '8px' }}>Copy your Publishable Key</li>
          <li style={{ marginBottom: '8px' }}>Create a <code style={{ backgroundColor: '#f3f4f6', padding: '2px 6px', borderRadius: '4px' }}>.env.local</code> file with:</li>
        </ol>
        <pre style={{ 
          backgroundColor: '#1f2937', 
          color: '#10b981', 
          padding: '12px', 
          borderRadius: '6px',
          marginBottom: '16px',
          overflow: 'auto'
        }}>VITE_CLERK_PUBLISHABLE_KEY=pk_test_your_key_here</pre>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>
          See <code style={{ backgroundColor: '#f3f4f6', padding: '2px 6px', borderRadius: '4px' }}>AUTH_SETUP.md</code> for detailed instructions.
        </p>
      </div>
    </div>
  )
  // Stop here - don't try to render the app
} else {
  // Clerk is configured, render the app normally
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    </React.StrictMode>,
  )
}

